import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import Members from "./pages/Members";
import Events from "./pages/Events";
import Impact from "./pages/Impact";
import Benefits from "./pages/Benefits";
import Rules from "./pages/Rules";
import Auth from "./pages/Auth";
import Portal from "./pages/Portal";
import Admin from "./pages/Admin";
import ChapterHome from "./pages/ChapterHome";
import ResetPassword from "./pages/ResetPassword";
import VisitMeeting from "./pages/VisitMeeting";
import Unsubscribe from "./pages/Unsubscribe";
import Stories from "./pages/Stories";
import StoryDetail from "./pages/StoryDetail";
import Apply from "./pages/Apply";
import PayDues from "./pages/PayDues";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <Routes>
          {/* Main organizational pages */}
          <Route path="/" element={<Index />} />
          <Route path="/impact" element={<Impact />} />
          <Route path="/impact/stories" element={<Stories />} />
          <Route path="/impact/stories/:slug" element={<StoryDetail />} />
          <Route path="/benefits" element={<Benefits />} />
          <Route path="/rules" element={<Rules />} />
          <Route path="/auth" element={<Auth />} />
          <Route path="/portal" element={<Portal />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/visit-a-meeting" element={<VisitMeeting />} />
          <Route path="/unsubscribe" element={<Unsubscribe />} />
          <Route path="/apply" element={<Apply />} />
          <Route path="/pay-dues" element={<PayDues />} />
          
          {/* Washington chapter routes */}
          <Route path="/washington" element={<ChapterHome />} />
          <Route path="/washington/members" element={<Members />} />
          <Route path="/washington/events" element={<Events />} />
          
          {/* Union chapter routes */}
          <Route path="/union" element={<ChapterHome />} />
          <Route path="/union/members" element={<Members />} />
          <Route path="/union/events" element={<Events />} />
          
          {/* Catch all */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;